import React, { useRef, useState } from 'react';

import { Row } from '@zillow/zrs-comet';

import AuthCheckWrapper from 'app/shared/containers/AuthCheckWrapper';
import PermissionCheck from 'app/shared/components/PermissionCheck';
import ConnectedModuleCardConstants from 'app/shared/constants/ConnectedModuleCardConstants';
import ConnectedListing from 'app/shared/components/ConnectedListing';
import ConnectedModuleCard from 'app/shared/components/ConnectedModuleCard';
import ConnectedInterestedRenters from 'app/shared/components/ConnectedInterestedRenters';
import { FIND_TENANTS_PATH } from 'app/shared/constants/RouteConstants';

import { StyledCol } from './StyledComponents';

const FindTenantsPage = () => {
    const connectedListingRef = useRef(null);
    const connectedInteractedRentersRef = useRef(null);

    const [minHeightXL, setMinHeightXL] = useState(ConnectedModuleCardConstants.FIND_TENANTS_MODULE_MIN_HEIGHT_XL);

    const updateMinModuleHeight = () => {
        const listingContainerHeight = connectedListingRef.current
            ? connectedListingRef.current.clientHeight
            : 0;

        const interestedRentersContainerHeight = connectedInteractedRentersRef.current
            ? connectedInteractedRentersRef.current.clientHeight
            : 0;

        const maxValue = `${Math.max(listingContainerHeight, interestedRentersContainerHeight)}px`;

        setMinHeightXL(maxValue);
    };

    return (
        <AuthCheckWrapper requireStrongAuthentication={false}>
            <PermissionCheck route={FIND_TENANTS_PATH}>
                <Row
                    paddingX={0}
                    paddingY={0}
                >
                    <StyledCol
                        paddingY={0}
                        marginBottom="sm"
                        xs={12}
                        xl={4}
                    >
                        <div className="ConnectedListing-Ref-Container" ref={connectedListingRef}>
                            <ConnectedListing
                                minHeightXL={minHeightXL}
                                updateMinModuleHeight={updateMinModuleHeight}
                            />
                        </div>
                    </StyledCol>

                    {/* Interested Renters */}
                    <StyledCol
                        paddingY={0}
                        xs={12}
                        xl={8}
                    >
                        <div className="ConnectedListing-Ref-Container" ref={connectedInteractedRentersRef}>
                            <ConnectedModuleCard
                                title="Interested Renters"
                                minHeightXL={minHeightXL}
                            >
                                <ConnectedInterestedRenters updateMinModuleHeight={updateMinModuleHeight} />
                            </ConnectedModuleCard>
                        </div>
                    </StyledCol>
                </Row>
            </PermissionCheck>
        </AuthCheckWrapper>
    );
};

FindTenantsPage.propTypes = {};
FindTenantsPage.defaultProps = {};

export default FindTenantsPage;
